import * as React from "react";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType, UitkMenuList } from "uitk-react-menu";
import { UitkLink, UitkLinkAlign } from "uitk-react-link";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { GtTypeMenuProps } from "../../typings";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "../l10n";

export const GroundTransportTypeMenu: React.FunctionComponent<GtTypeMenuProps> = (props) => {
  const { formatText } = useLocalization();
  const items = [
    {
      attributes: {
        role: "menuItem",
        tabindex: 0,
      },
      className: "uitk-list-item",
      label: formatText(locKeys.gtSubLOBFrom),
      onClick: props.onSubLOBMenuItemClick("fromAirport"),
      typeAnchor: true,
      href: "#",
    },
    {
      attributes: {
        role: "menuItem",
        tabindex: 0,
      },
      className: "uitk-list-item",
      label: formatText(locKeys.gtSubLOBTo),
      onClick: props.onSubLOBMenuItemClick("toAirport"),
      typeAnchor: true,
      href: "#",
    },
  ];

  return (
    <UitkLayoutFlexItem>
      <UitkMenu id="gt-type-menu" isOpen={props.isSubLOBMenuOpen} onTriggerClick={props.onSubLOBMenuTriggerClick}>
        <UitkMenuTrigger>
          <UitkLink iconPos={UitkLinkAlign.RIGHT}>
            <button type="button">
              {props.setType()}
              <UitkIcon name="expand_more" size={UitkIconSize.SMALL} />
            </button>
          </UitkLink>
        </UitkMenuTrigger>
        <UitkMenuContainer position={PositionType.LEFT}>
          <UitkMenuList items={items} />
        </UitkMenuContainer>
      </UitkMenu>
    </UitkLayoutFlexItem>
  );
};
